import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxResetPassword() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="reset-password" /></AuthShell>;
}

export default AuthWithBoxResetPassword;
